export const OVERLAY_TIME_DELAY_LONG = 1000;
